import { Fragment } from 'react'

import Text from '../../Text'
import { Radio } from '../Radio'

import * as styles from './RadioGroup.module.css'

function RadioGroup({
  Divider,
  RadioComponent = Radio,
  className = styles.RadioGroup,
  disabled,
  options,
  radioComponentProps,
  title,
  value,
  onBlur,
  onChange,
}) {
  function getHandleChange(option) {
    return () => {
      onChange(option.id)
    }
  }

  return (
    <div className={className}>
      {title ? <Text className={styles.title}>{title}</Text> : null}
      {options.map((option, index) => (
        <Fragment key={option.id}>
          <RadioComponent
            {...radioComponentProps}
            checked={option.id === value}
            disabled={disabled}
            id={option.id}
            label={option.label}
            onBlur={onBlur}
            onChange={getHandleChange(option)}
          />
          {index < options.length - 1 ? Divider && <Divider /> : null}
        </Fragment>
      ))}
    </div>
  )
}

export default RadioGroup
